/** @format */

import React, { useState } from 'react'
import classNames from 'classnames'

import styles from './input.module.scss'

export const Input = ({
  type,
  placeholder,
  icon,
  value,
  iconHover,
  onSubmit,
  onChange,
}) => {
  const [focus, setFocus] = useState(false)
  const handleValue = (e) => onChange(e.target.value)
  const handleFocus = () => setFocus(!focus)
  const handleKeyDown = (e) => e.keyCode === 13 && onSubmit()

  const wrapperStyle = classNames({
    [styles.wrapper]: true,
    [styles.wrapperFocus]: focus || value,
  })

  const inputStyle = classNames({
    [styles.input]: true,
    [styles.inputFocus]: focus || value,
  })

  return (
    <div className={wrapperStyle}>
      {!!icon && !focus && !value ? (
        <img className={styles.icon} src={icon} alt={placeholder} />
      ) : (
        <img className={styles.icon} src={iconHover} alt={placeholder} />
      )}
      <input
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleFocus}
        type={type}
        placeholder={placeholder}
        onChange={handleValue}
        className={inputStyle}
        value={value}
      />
    </div>
  )
}
